import { Link } from 'react-router-dom';
import { ClipboardList, Calendar, Palmtree, Receipt } from 'lucide-react';
import { useFeatureToggles } from '../FeatureToggleProvider';

interface Props {
  stepsCompleted: number;
  totalSteps: number;
  isSubmitted: boolean;
}

export default function QuickActions({ stepsCompleted, totalSteps, isSubmitted }: Props) {
  const { isRouteEnabled } = useFeatureToggles();
  const actions = [
    {
      href: '/onboarding',
      icon: ClipboardList,
      label: 'Onboarding',
      sub: isSubmitted ? '✓ Submitted' : `${stepsCompleted}/${totalSteps} steps done`,
      active: !isSubmitted,
    },
    {
      href: '#',
      icon: Calendar,
      label: 'Shifts',
      sub: 'Coming soon',
      active: false,
    },
    {
      href: '#',
      icon: Palmtree,
      label: 'Holidays',
      sub: 'Coming soon',
      active: false,
    },
    {
      href: '#',
      icon: Receipt,
      label: 'Payslips',
      sub: 'Coming soon',
      active: false,
    },
  ];

  const filtered = actions.filter(a => a.href === '#' || isRouteEnabled(a.href));

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
      {filtered.map(a => (
        <Link key={a.label} to={a.href} className={`bg-card border rounded-lg p-4 text-center transition-colors ${a.active ? 'border-primary/30 hover:border-primary/60' : 'border-border opacity-60 cursor-default pointer-events-none'}`}>
          <a.icon className={`w-6 h-6 mx-auto mb-2 ${a.active ? 'text-primary' : 'text-muted-foreground'}`} />
          <p className="text-sm font-medium text-foreground">{a.label}</p>
          <p className={`text-xs mt-0.5 ${a.active && !a.sub.startsWith('✓') ? 'text-amber-400' : 'text-muted-foreground'}`}>{a.sub}</p>
        </Link>
      ))}
    </div>
  );
}
